import { OnboardLayoutProps } from "@components/layouts/Onboarding/types";
import OnboardPageLayout from "../../../OnboardPageLayout";

interface OnboardDialogPageLayoutProps extends OnboardLayoutProps {}

const OnboardDialogPageLayout = (props: OnboardDialogPageLayoutProps) => {
  return <OnboardPageLayout {...props} />;
};

export default OnboardDialogPageLayout;
